import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { Task } from "src/api/types";
import { theme } from "src/assets/theme";
import WhiteCard from "src/components/WhiteCard";

const taskDescriptions: Record<string, string> = {
  SYNC_VISIT_REQUEST:
    "Patient requested a sync visit with provider. Accept an invitation to meet with patient",
  PRESCRIPTION_REQUEST:
    "Review the patient’s intake form to determine eligibility, add a clinical note summarizing your assessment, and prescribe the appropriate medication if clinically indicated.",
  SEND_MESSAGE:
    "Review the patient’s chart and send a clear, appropriate message based on the context provided—this could include follow-up instructions, clarifying questions, or next steps in their care.",
  PRESCRIPTION_REVIEW:
    "Review the patient’s intake form to determine eligibility, add a clinical note summarizing your assessment, and prescribe the appropriate medication if clinically indicated.",
  PRIOR_AUTH_REQUEST:
    "Review the patient's prescription request and clinical history, verify medical necessity, and submit the prior authorization request through the e-prescribing portal.",
};

interface Props {
  task: Task;
  action?: () => void;
  children: React.ReactNode;
  forwardingReason?: string;
}
const TaskWrapper = ({ task, children, action, forwardingReason }: Props) => {
  const description = useMemo(() => {
    const d = forwardingReason
      ? `Forward reason: ${forwardingReason}`
      : task.note
        ? task.note
        : taskDescriptions[task.task_type];

    return d ?? "You are the best!!! Remember that";
  }, [forwardingReason, task.note, task.task_type]);

  const showForwardingButton = useMemo(
    () => task.task_type === "UNREAD_MESSAGE" && task.queue === "Coordinator",
    [task.queue, task.task_type],
  );

  const taskType = useMemo(() => {
    return task.task_type.split("_").join(" ");
  }, [task.task_type]);

  return (
    <>
      <WhiteCard
        gap={1}
        sx={{
          background: theme.palette.secondary.light,
          pl: 1,
          pr: 1,
          boxShadow: "0px 3px 17px 0px rgba(204, 82, 72, 0.5);",
        }}
      >
        <Stack gap={1.5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Stack width="100%">
              <Typography variant="h5" color={theme.palette.secondary.dark}>
                {taskType}
              </Typography>
              <Typography>{description}</Typography>
            </Stack>
            {showForwardingButton ? (
              <Button onClick={action}>Forward to provider</Button>
            ) : null}
          </Stack>
          {children}
        </Stack>
      </WhiteCard>
    </>
  );
};

export default TaskWrapper;
